import dateFormat from "dateformat";

export const getDateDiffInDays = (date2) => {
  date2 = new Date(new Date(date2).toISOString().replace("-", "/").split("T")[0].replace("-", "/"));
  const date1 = new Date(new Date().toISOString().replace("-", "/").split("T")[0].replace("-", "/"));
  const diffTime = Math.abs(date2 - date1);
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

export const getDateDiffString = (date) => {
  const days = getDateDiffInDays(date);
  if (days === 0) {
    return "Today";
  } else {
    return `${days} ${days === 1 ? `day` : `days`} left`;
  }
};
export const getDate = (date, format, showDayName = false) => {
  if (showDayName) {
    if (getDateDiffInDays(date) === 0) {
      return "Today";
    }
    if (getDateDiffInDays(date) === 1) {
      return "Yesterday";
    }
  }
  date = new Date(date);
  return dateFormat(
    new Date(dateFormat(date, "yyyy"), dateFormat(date, "mm") - 1, parseInt(dateFormat(date, "dd"))),
    format
  );
};

export const isDateBetween = (startDate, endDate, date) => {
  startDate = new Date(startDate.format("LL"));
  endDate = new Date(endDate.format("LL"));
  date = new Date(date);
  return date >= startDate && date <= endDate;
};

export const isDateEqual = (startDate, date) => {
  date = getDateOnly(date);
  startDate = getDateOnly(startDate);
  return date.getTime() === startDate.getTime();
};

export const isDateGreater = (startDate, date) => {
  date = getDateOnly(date);
  startDate = getDateOnly(startDate);
  return date.getTime() >= startDate.getTime();
};

const getDateOnly = (dateString) => {
  return new Date(new Date(dateString).toISOString().replace("-", "/").split("T")[0].replace("-", "/"));
}
